module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1022-f966d769fbce140a3a0513d04c76ade7.png";